module.exports = __webpack_public_path__ + "static/media/shopping-xs.7fa8a8cb.jpg";